import { store } from '../../store'
import { plainToClass } from 'class-transformer'
import { SaveCourseDTO } from '../../dto/courses'
import { validate } from 'class-validator'

export const saveCourse = async ( course: any ) => {

    let body, response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/courses`, {
            body: JSON.stringify( course ),
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'POST'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'SAVE_COURSE_TIMEOUT' } )
        return null

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'SAVE_COURSE_UNAUTHORIZED' } )
        return null

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'SAVE_COURSE_UNEXPECTEDRESPONSE' } )
        return null

    }

    try {

        body = plainToClass( SaveCourseDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'SAVE_COURSE_INVALIDJSON' } )
        return null

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'SAVE_COURSE_INVALIDRESPONSE' } )
        return null

    }

    store.dispatch( { type: 'SAVE_COURSE_OK' } )
    return body.course

}